import MrtCaseTable from "@/components/Table/MrtCaseTable.tsx";
import { Typography } from "@mui/material";
import { type ReactNode, useEffect } from "react";
import { Outlet } from "react-router-dom";

const CasesPage = (): ReactNode => {
    useEffect(() => {
        document.title = "Cases";
    }, []);

    return (
        <>
            <Typography variant="h4" mb={2}>
                Cases
            </Typography>

            <MrtCaseTable />
            <Outlet />
        </>
    );
};

export default CasesPage;
